import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { TRIVIA_REPORT } from "../../../../graphql/queries/ReportQueries";
import { WithQueryLoader } from "../../../shared/WithQueryLoader";
import { ChartHeader } from "../../ChartHeader";
import { GameReportProps } from "../../GameReport/GameReport";
import { Chart, TriviaChartData } from "../Chart/Chart";

import styles from "../TriviaChart.module.scss";

export const Aggregated = ({ game }: GameReportProps) => {
  const { t } = useTranslation();
  const { data, loading } = useQuery(TRIVIA_REPORT, {
    variables: {
      gameId: game.id,
    },
  });

  const chartData = useMemo((): TriviaChartData[] => {
    if (!data) return [];

    return data.triviaReport.questionResults.map((questionResult) => ({
      id: questionResult.question.id,
      question: questionResult.question.question,
      options: questionResult.scores.map((score) => ({
        text: score.option.text,
        count: score.count,
      })),
    }));
  }, [data]);

  return (
    <WithQueryLoader isLoading={loading}>
      <div className={styles.container}>
        <ChartHeader respondersCount={data?.triviaReport.totalResponses}>
          {t("report:trivia.header.aggregated")}
        </ChartHeader>
      </div>

      {chartData.map((row) => (
        <Chart key={row.id} data={row} />
      ))}
    </WithQueryLoader>
  );
};
